'use strict';

var $d = require('../dependency');
var _ = $d._;

exports.trendModifyResponse = trendModifyResponse;

function trendModifyResponse(context, config, next) {
    var model = context.apiMergedResponse,
      computedModel = {};
    _.forEach(_.values(config.dataSeries), function (seriesName) {
        computedModel[seriesName] = model[seriesName];
    });

    context.chartData = computedModel;
    next();
}